export default "__VITE_ASSET__D3FUaO5t__"